// extracted by mini-css-extract-plugin
export var dropdownIcon = "_oo-6";
export var imgContainer = "_oo-3";
export var menuIcon = "_oo-5";
export var pillWrapper = "_oo-2";
export var pillsContainer = "_oo-1";
export var subscriptionCard = "_oo-0";
export var subscriptionLogo = "_oo-4";